import { IRepasseSetorialPagedResponse } from "models/response/repasse-setorial-paged-response";

export interface RepasseSetorialDetailsState {
  repasseSetorialDetails: IRepasseSetorialPagedResponse | null;
  loading: boolean;
  error: string | null;
}

export const ACTION_TYPES = {
  setRepasseSetorialDetails: 'setRepasseSetorialDetails',
  setLoading: 'setLoading',
  setError: 'setError',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface RepasseSetorialDetailsAction {
  type: ActionType;
  payload: any;
}

export const RepasseSetorialDetailsReducer = (
  state: RepasseSetorialDetailsState,
  action: RepasseSetorialDetailsAction
): RepasseSetorialDetailsState => {
  switch (action.type) {
    case ACTION_TYPES.setRepasseSetorialDetails:
      return { ...state, repasseSetorialDetails: action.payload, error: null };
    case ACTION_TYPES.setLoading:
      return { ...state, loading: action.payload };
    case ACTION_TYPES.setError:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};
